import { Actions, thunk } from 'easy-peasy';
import { normalizeDateStringWithCurrentUtcTime } from '~/utils/date/date';
import api from '~/services/api';
import { IThunkArchiveClient, IClientStore, IClientActions } from '../types';

const onArchiveClient: IThunkArchiveClient = thunk(
  async (
    { setClients, setDefaultClient, setClient, setClientOptionsByTeam }: Actions<IClientActions>,
    payload,
    { getState },
  ) => {
    const localState = getState() as IClientStore;
    const { clientId, clinicId, teamId, dischargeReasonId, dischargeDate, id } = payload;

    await api.clientTeams.archiveTeam({
      clinicId,
      teamId,
      clientId,
      id,
      dischargeReasonId,
      dischargeDate: normalizeDateStringWithCurrentUtcTime(dischargeDate),
    });

    const updatedList = localState.list.map(item =>
      String(item.id) !== clientId ? item : { ...item, isArchived: true },
    );

    setClients({ items: updatedList });
    setDefaultClient(null);
    setClient(null);
    setClientOptionsByTeam({
      items: localState.clientOptionsByTeam.list,
      archived: [Number(clientId)],
    });
  },
);

export default onArchiveClient;
